import { ConnectionType, LinkedCentralSystem, OcppVersion } from '@infuse/e-connector/central-system/domain';

export interface ChargingStation {
  id: number;
  name: string;
  alias?: string[];
  type: ConnectionType;
  ocppVersion: OcppVersion;
  uri?: string;
  useManualURI: boolean;
  useRequestHeader: boolean;
  omitSoapHeader: boolean;
  linkedCentralSystems: LinkedCentralSystem[];
  basicAuthStatus: BasicAuthStatus;
  basicAuthPassword?: string;
  basicAuthDeviationId?: string;
  networkProfileId: number;
  networkProfileName: string;
  createdAt: Date;
  updatedAt: Date;
  basicAuthLastPasswordChange: Date;
}

export enum BasicAuthStatus {
  NOT_REQUIRED = 'NOT_REQUIRED',
  REQUIRED = 'REQUIRED',
  CONFIGURE_NEXT_CONNECT = 'CONFIGURE_NEXT_CONNECT',
  ENABLE_NEXT_CONNECT = 'ENABLE_NEXT_CONNECT'
}

export interface ImportChargeStationsResponse {
  imported: ImportedChargingStation[];
  failed: FailedImport[];
}

export interface ImportedChargingStation {
  name: string;
  centralSystemName: string;
  customName?: string;
  commandsAllowed: boolean;
  sessionAuthorizationAllowed: boolean;
}

export interface FailedImport {
  chargingStation: ImportedChargingStation;
  error: string;
}
